import { Component, Input } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { InputComponent } from '../input/input.component';
import { FiltreService } from '../../filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-phone-mask-input',
  templateUrl: './phone-mask-input.component.html',
  styleUrls: ['../input/input.component.css']
})
export class PhoneMaskInputComponent extends InputComponent {
  @Input()
  maskFormat: string = '00 00 00 00 00';
  // Attention 1 seul format à la fois fonctionne 
  // l'option de mettre plusieurs formats de la forme : '00 00 00 00 00||000 00 00 00' est buggee sur la librairie!!

  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
     super(formulaireService, libelleService, filtreService, modeRenduService);
   }
}